import { Divider, Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { OrderJobParamsFormFields, OrderJobParamsSchema } from './Common/Orders';
import { type AsynchronousJobVariant, NullableStringSchema, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExtractMedicalNecessityVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExtractMedicalNecessity),
    payload: OrderJobParamsSchema.merge(
      z.object({
        payor: RequiredStringSchema,
        procedures: z.union([
          z.array(
            z
              .object({
                id: RequiredStringSchema,
                description: RequiredStringSchema,
                cptCode: NullableStringSchema,
                rawDiagnoses: NullableStringSchema,
                diagnoses: z.array(
                  z
                    .object({
                      description: RequiredStringSchema,
                      icd10Codes: z.array(RequiredStringSchema).nullable(),
                    })
                    .strip()
                ),
              })
              .strip()
          ),
          RequiredStringSchema,
        ]),
      })
    ),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        {/* Payor Information */}
        <BlockValueTemplateField
          fieldName="config.payload.payor"
          label="Payor"
          helperText="Enter the reference to the payor."
          placeholder="e.g. {{order.data.payor}}"
        />
        <Divider />
        {/* Procedures */}
        <BlockValueTemplateField
          fieldName="config.payload.procedures"
          label="Procedures"
          helperText="Enter the reference to the procedures."
          placeholder="e.g. {{order.data.procedures}}"
        />
        <Divider />
        {/* Order Job Params */}
        <OrderJobParamsFormFields />
      </Stack>
    );
  },
};
